import { render, staticRenderFns } from "./MapSwitch.vue?vue&type=template&id=7b958356&scoped=true&"
import script from "./MapSwitch.vue?vue&type=script&lang=js&"
export * from "./MapSwitch.vue?vue&type=script&lang=js&"
import style0 from "./MapSwitch.vue?vue&type=style&index=0&id=7b958356&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b958356",
  null
  
)

export default component.exports